<div class="wrapper-hero-image">
  <ngx-skeleton-loader
    [theme]="{height: '445px', width: '100%', 'border-radius':'0', 'aspect-ratio':'4/1', 'margin': '0'}"
    appearance="circle"
  ></ngx-skeleton-loader>
</div>
<div class="container">
  <div class="grid">
    <div class="col col-md-6">
      <ngx-skeleton-loader
        [theme]="{height: '285px', width: '100%', 'border-radius':'0', 'margin': '0 0 20px 0'}"
        appearance="circle"
      ></ngx-skeleton-loader>
    </div>
    <div class="col col-md-6">
      <ngx-skeleton-loader
        [theme]="{height: '45px', 'border-radius':'0'}"
        appearance="line"
        count="2"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '103px', 'border-radius':'0'}"
        appearance="line"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: '150px', 'border-radius':'5px'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="grid content-center">
    <div class="col col-md-4 mt-100">
      <ngx-skeleton-loader
        [theme]="{height: '100px', width: '100px', 'border-radius':'50%', 'margin': '0 auto 5px'}"
        appearance="circle"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: 'calc(100% - 70px)', 'border-radius':'0'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
    <div class="col col-md-4 mt-100">
      <ngx-skeleton-loader
        [theme]="{height: '100px', width: '100px', 'border-radius':'50%', 'margin': '0 auto 5px'}"
        appearance="circle"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: 'calc(100% - 70px)', 'border-radius':'0'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
    <div class="col col-md-4 mt-100">
      <ngx-skeleton-loader
        [theme]="{height: '100px', width: '100px', 'border-radius':'50%', 'margin': '0 auto 5px'}"
        appearance="circle"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '50px', width: 'calc(100% - 70px)', 'border-radius':'0'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>
